/* ANAR – theme scripts (no dependencies) */
(function () {
  'use strict';

  var T = window.theme || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '{{amount}} €';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return String(cents);
    function fmt(n, decimals, thousands, dec) {
      n = (Number(n) / 100).toFixed(decimals);
      var parts = n.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? parts[0] + dec + parts[1] : parts[0];
    }
    var value;
    switch (match[1]) {
      case 'amount': value = fmt(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2, ',', '.');
    }
    return format.replace(match[0], value);
  }
  T.formatMoney = formatMoney;

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(message, actionLabel, action) {
    var el = $('[data-toast]');
    if (!el) return;
    el.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = message;
    el.appendChild(span);
    if (actionLabel && action) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = actionLabel;
      b.addEventListener('click', function () { el.hidden = true; action(); });
      el.appendChild(b);
    }
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, actionLabel ? 8000 : 3500);
  }
  T.toast = toast;

  /* ---------- Drawers & modals ---------- */
  var openDrawer = null;
  var lastFocus = null;

  function getPanel(name) { return $('[data-drawer="' + name + '"]'); }

  function open(name, trigger) {
    var panel = getPanel(name);
    if (!panel) return false;
    if (openDrawer && openDrawer !== panel) close();
    lastFocus = trigger || document.activeElement;
    panel.hidden = false;
    $('[data-overlay]').hidden = false;
    document.body.classList.add('is-locked');
    $$('[data-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    openDrawer = panel;
    if (name === 'favorites-drawer') favRefresh();
    var focusable = panel.querySelector('[data-close], button, a, input, select');
    if (focusable) setTimeout(function () { focusable.focus(); }, 50);
    return true;
  }

  function close() {
    if (!openDrawer) return;
    var name = openDrawer.getAttribute('data-drawer');
    openDrawer.hidden = true;
    $('[data-overlay]').hidden = true;
    document.body.classList.remove('is-locked');
    $$('[data-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    openDrawer = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  T.openDrawer = open;
  T.closeDrawer = close;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      if (open(opener.getAttribute('data-open'), opener)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-close]') || e.target.closest('[data-overlay]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
    if (e.key === 'Tab' && openDrawer) {
      var items = $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea', openDrawer)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    }
  });

  /* Drawers inside the sticky header would sit below the overlay: move them to <body>. */
  function liftDrawers() {
    $$('.section-header [data-drawer]').forEach(function (d) { document.body.appendChild(d); });
  }

  function setHeaderHeight() {
    var h = $('.section-header');
    if (h) document.documentElement.style.setProperty('--header-h', h.offsetHeight + 'px');
  }

  /* ---------- Cart ---------- */
  function sectionsToRender() {
    var ids = [];
    if ($('#CartDrawer')) ids.push('cart-drawer');
    return ids;
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = Number(count) === 0;
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    });
  }

  function renderDrawer(html) {
    var current = $('#CartDrawer');
    if (!current || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('#CartDrawer');
    if (!fresh) return;
    current.innerHTML = fresh.innerHTML;
    var count = fresh.getAttribute('data-cart-count-value');
    if (count !== null) updateCount(count);
    initShipping(current);
  }

  /* Personalisation fee: for every personalisation the customer ticks (snippets/personalize.liquid: name / short
     text, design change) or a filled personalisation text field of Globo product options, the matching variant
     of the fee product from the theme settings is added once per item and kept in sync with that item's quantity. */
  var FEE = T.personalizeFee;
  function persoBox(form) {
    var formId = form.getAttribute && form.getAttribute('id'); // an input named "id" hides form.id
    return formId ? $$('[data-perso]').filter(function (b) { return b.getAttribute('data-form-id') === formId; })[0] : null;
  }
  function persoTicked(box) {
    return box ? $$('input[type="checkbox"][data-perso-variant]:checked', box) : [];
  }
  // the fee variants to add for this form (none when nothing is personalised)
  function feeVariants(form) {
    if (!FEE) return [];
    var ticked = persoTicked(persoBox(form));
    if (ticked.length) return ticked.map(function (el) { return Number(el.getAttribute('data-perso-variant')); });
    var scope = form.closest('.shopify-section') || document;
    var globo = $$('.gpo-app input[type="text"], .gpo-app textarea', scope).some(function (el) {
      return el.value.trim() !== '' && el.offsetParent !== null;
    });
    return globo ? [FEE.id] : [];
  }
  function isPersonalised(form) {
    return feeVariants(form).length > 0;
  }
  function addFee(item, qty, sections, variantIds) {
    if (item && item.items) item = item.items[0];
    if (!item || !item.key) return Promise.resolve(null);
    var props = { _fee_for: item.key };
    props[FEE.forLabel] = item.product_title;
    var body = { items: (variantIds && variantIds.length ? variantIds : [FEE.id]).map(function (id) {
      return { id: id, quantity: qty, properties: props };
    }) };
    if (sections.length) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }
    return fetch(T.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
      .then(function (r) { return r.ok && !r.json.status ? r : null; })
      .catch(function () { return null; });
  }
  // the first fee line whose quantity no longer matches its item (0 when the item is gone)
  function feeFix(cart) {
    var items = cart.items || [], fix = null;
    items.some(function (it) {
      var forKey = (it.properties || {})._fee_for;
      if (!forKey) return false;
      var main = items.filter(function (m) { return m.key === forKey; })[0];
      var want = main ? main.quantity : 0;
      if (it.quantity !== want) { fix = { id: it.key, quantity: want }; return true; }
      return false;
    });
    return fix;
  }
  function initFeeNote() {
    if (!FEE) return;
    var tries = 0;
    var timer = setInterval(function () {
      $$('.gpo-app').forEach(function (app) {
        // Where the theme's own personalisation is shown, a Globo set holding only a wish-text field is a duplicate.
        var section = app.closest('.shopify-section') || document;
        var fields = $$('input, textarea, select', app).filter(function (el) { return el.type !== 'hidden'; });
        if (section.querySelector('[data-perso]') && fields.length && fields.every(function (el) { return el.type === 'text' || el.tagName === 'TEXTAREA'; })) {
          fields.forEach(function (el) { el.value = ''; });
          app.style.display = 'none';
          return;
        }
        if (!app.querySelector('input[type="text"], textarea') || app.parentNode.querySelector('.fee-note')) return;
        var note = document.createElement('p');
        note.className = 'fee-note';
        note.textContent = FEE.note;
        app.insertAdjacentElement('afterend', note);
      });
      if (++tries > 30) clearInterval(timer);
    }, 500);
  }
  initFeeNote();

  // Ticking a personalisation opens its text field; only ticked ones go to the order (and are charged).
  document.addEventListener('change', function (e) {
    var tick = e.target;
    if (!tick.matches || !tick.matches('[data-perso] input[type="checkbox"][data-perso-variant]')) return;
    var opt = tick.closest('[data-perso-opt]');
    var box = tick.closest('[data-perso]');
    var input = opt.querySelector('[data-perso-input]');
    opt.querySelector('[data-perso-box]').hidden = !tick.checked;
    input.disabled = !tick.checked;
    input.required = tick.checked;
    input.classList.remove('is-invalid');
    box.querySelector('[data-perso-error]').hidden = true;
    box.querySelector('[data-perso-hint]').hidden = !persoTicked(box).length;
    if (tick.checked) input.focus();
  });
  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-perso-input]')) return;
    e.target.classList.remove('is-invalid');
    e.target.closest('[data-perso]').querySelector('[data-perso-error]').hidden = true;
  });
  // Do not add to cart when a personalisation is ticked but nothing was written.
  document.addEventListener('submit', function (e) {
    var box = persoBox(e.target);
    var input = persoTicked(box).map(function (tick) {
      return tick.closest('[data-perso-opt]').querySelector('[data-perso-input]');
    }).filter(function (el) { return !el.value.trim(); })[0];
    if (!input) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    input.classList.add('is-invalid');
    box.querySelector('[data-perso-error]').hidden = false;
    input.scrollIntoView({ behavior: 'smooth', block: 'center' });
    input.focus({ preventScroll: true });
  }, true);

  function addToCart(form, button) {
    var data = new FormData(form);
    var sections = sectionsToRender();
    var fee = feeVariants(form);
    if (sections.length && !fee.length) {
      data.append('sections', sections.join(','));
      data.append('sections_url', window.location.pathname);
    }
    if (button) button.classList.add('is-loading');
    return fetch(T.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) {
          toast(res.json.description || res.json.message || T.strings.cartError);
          return null;
        }
        if (!fee.length) return res;
        return addFee(res.json, Number(data.get('quantity')) || 1, sections, fee).then(function (r) { return r || res; });
      })
      .then(function (res) {
        if (!res) return;
        if (T.cartType !== 'drawer') { window.location.href = T.routes.cart; return; }
        if (res.json.sections && res.json.sections['cart-drawer']) {
          renderDrawer(res.json.sections['cart-drawer']);
          open('cart-drawer');
        } else {
          fetch(T.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (cart) { updateCount(cart.item_count); });
          toast(T.strings.added);
        }
        document.dispatchEvent(new CustomEvent('cart:added', { detail: res.json }));
      })
      .catch(function () { toast(T.strings.cartError); })
      .finally(function () { if (button) button.classList.remove('is-loading'); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ajax-cart]');
    if (!form || e.defaultPrevented) return;
    if (T.cartType !== 'drawer' && !isPersonalised(form)) return;
    e.preventDefault();
    addToCart(form, form.querySelector('[type="submit"]'));
  });

  function changeCart(body) {
    var sections = sectionsToRender();
    if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }
    return fetch(T.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.status) return cart;
        var fix = feeFix(cart);
        return fix ? changeCart(fix) : cart;
      });
  }

  function changeLine(lineEl, quantity) {
    var line = Number(lineEl.getAttribute('data-line'));
    lineEl.classList.add('is-loading');
    return changeCart({ line: line, quantity: Math.max(0, quantity) })
      .then(function (cart) {
        if (cart.status) { toast(cart.description || T.strings.cartError); lineEl.classList.remove('is-loading'); return; }
        if ($('[data-cart-page]') || !cart.sections) { window.location.reload(); return; }
        renderDrawer(cart.sections['cart-drawer']);
      })
      .catch(function () { lineEl.classList.remove('is-loading'); toast(T.strings.cartError); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (btn) {
      var lineEl = btn.closest('[data-line]');
      if (lineEl) { e.preventDefault(); changeLine(lineEl, Number(btn.getAttribute('data-qty-change'))); }
      return;
    }
    var step = e.target.closest('[data-qty-step]');
    if (step) {
      var input = step.parentElement.querySelector('input');
      var v = Math.max(Number(input.min || 1), (Number(input.value) || 1) + Number(step.getAttribute('data-qty-step')));
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input) changeLine(input.closest('[data-line]'), Number(input.value));
  });

  /* Free shipping bar (threshold is in EUR cents, converted to the visitor currency) */
  function initShipping(root) {
    $$('[data-free-shipping]', root).forEach(function (bar) {
      var rate = (window.Shopify && Shopify.currency && Number(Shopify.currency.rate)) || 1;
      var threshold = Math.round(Number(bar.getAttribute('data-threshold')) * rate);
      var total = Number(bar.getAttribute('data-total'));
      var text = bar.querySelector('[data-ship-text]');
      var fill = bar.querySelector('[data-ship-fill]');
      var pct = Math.min(100, Math.round((total / threshold) * 100));
      if (total >= threshold) {
        text.textContent = text.getAttribute('data-done');
      } else {
        text.textContent = text.getAttribute('data-remaining').replace('[amount]', formatMoney(threshold - total));
      }
      requestAnimationFrame(function () { fill.style.width = Math.max(4, pct) + '%'; });
    });
  }

  /* ---------- Horizontal scrollers ---------- */
  function initScrollers(root) {
    $$('[data-scroller]', root).forEach(function (s) {
      if (s.dataset.ready) return;
      s.dataset.ready = '1';
      var track = s.querySelector('[data-scroller-track]');
      var prev = s.querySelector('[data-scroller-prev]');
      var next = s.querySelector('[data-scroller-next]');
      if (!track) return;
      function update() {
        var max = track.scrollWidth - track.clientWidth - 4;
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      function go(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Hero slider ---------- */
  function initSliders(root) {
    $$('[data-slider]', root).forEach(function (slider) {
      if (slider.dataset.ready) return;
      slider.dataset.ready = '1';
      var track = slider.querySelector('[data-slider-track]');
      var slides = $$('[data-slide]', slider);
      var dots = $$('[data-slider-dot]', slider);
      if (slides.length < 2) return;
      var index = 0;
      var delay = Number(slider.getAttribute('data-autoplay')) * 1000;
      var timer;

      function goTo(i) {
        index = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      function setActive() {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        index = i;
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      }
      function play() {
        stop();
        if (delay > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          timer = setInterval(function () { goTo(index + 1); }, delay);
        }
      }
      function stop() { clearInterval(timer); }

      track.addEventListener('scroll', function () { window.requestAnimationFrame(setActive); }, { passive: true });
      dots.forEach(function (d) { d.addEventListener('click', function () { goTo(Number(d.getAttribute('data-slider-dot'))); play(); }); });
      var p = slider.querySelector('[data-slider-prev]');
      var n = slider.querySelector('[data-slider-next]');
      if (p) p.addEventListener('click', function () { goTo(index - 1); play(); });
      if (n) n.addEventListener('click', function () { goTo(index + 1); play(); });
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', play);
      slider.addEventListener('focusin', stop);
      track.addEventListener('touchstart', stop, { passive: true });
      play();
    });
  }

  /* ---------- Countdown ---------- */
  function initCountdowns(root) {
    $$('[data-countdown]', root).forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var mode = el.getAttribute('data-mode');
      function target() {
        var now = new Date();
        if (mode === 'date') {
          var raw = (el.getAttribute('data-end') || '').trim().replace(' ', 'T');
          var d = new Date(raw);
          if (!isNaN(d)) return d;
        }
        var t = new Date(now);
        t.setHours(24, 0, 0, 0);
        if (mode === 'weekly') {
          var add = (7 - now.getDay()) % 7;
          t.setDate(t.getDate() + add);
        }
        return t;
      }
      var end = target();
      var cells = {};
      ['d', 'h', 'm', 's'].forEach(function (u) { cells[u] = el.querySelector('[data-unit="' + u + '"]'); });
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = Math.max(0, end - new Date());
        if (diff === 0 && mode !== 'date') { end = target(); diff = end - new Date(); }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400);
        var h = Math.floor((s % 86400) / 3600);
        var m = Math.floor((s % 3600) / 60);
        cells.d.hidden = d === 0;
        cells.d.querySelector('b').textContent = pad(d);
        cells.h.querySelector('b').textContent = pad(h);
        cells.m.querySelector('b').textContent = pad(m);
        cells.s.querySelector('b').textContent = pad(s % 60);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Product page ---------- */
  function initProducts(root) {
    $$('[data-product]', root).forEach(function (section) {
      if (section.dataset.ready) return;
      section.dataset.ready = '1';

      // Gallery
      var gallery = section.querySelector('[data-gallery]');
      var gTrack = gallery && gallery.querySelector('[data-gallery-track]');
      var thumbs = gallery ? $$('[data-thumb]', gallery) : [];
      function showMedia(i) {
        if (!gTrack) return;
        var slide = gTrack.children[i];
        if (slide) gTrack.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      if (gTrack) {
        thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(Number(t.getAttribute('data-thumb'))); }); });
        gTrack.addEventListener('scroll', function () {
          var i = Math.round(gTrack.scrollLeft / gTrack.clientWidth);
          thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
        }, { passive: true });
        var gp = gallery.querySelector('[data-gallery-prev]');
        var gn = gallery.querySelector('[data-gallery-next]');
        function current() { return Math.round(gTrack.scrollLeft / gTrack.clientWidth); }
        if (gp) gp.addEventListener('click', function () { showMedia((current() - 1 + gTrack.children.length) % gTrack.children.length); });
        if (gn) gn.addEventListener('click', function () { showMedia((current() + 1) % gTrack.children.length); });
      }

      // Variants
      var picker = section.querySelector('[data-variant-picker]');
      if (!picker) return;
      var variants = JSON.parse(picker.querySelector('[data-variants-json]').textContent);
      var fieldsets = $$('fieldset[data-option-index]', picker);
      var idInput = section.querySelector('[data-variant-id]');
      var addBtn = section.querySelector('[data-add-button]');
      var addLabel = section.querySelector('[data-add-label]');
      var priceWrap = section.querySelector('[data-product-price] [data-price]');

      function selected() {
        return fieldsets.map(function (fs) {
          var c = fs.querySelector('input:checked');
          return c ? c.value : null;
        });
      }
      function findVariant(opts) {
        return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
      }
      function markAvailability(opts) {
        fieldsets.forEach(function (fs, idx) {
          $$('input', fs).forEach(function (input) {
            var test = opts.slice();
            test[idx] = input.value;
            var match = variants.some(function (v) {
              return v.available && v.options.every(function (o, i) { return o === test[i]; });
            });
            input.classList.toggle('is-unavailable', !match);
          });
        });
      }
      function update() {
        var opts = selected();
        fieldsets.forEach(function (fs, i) {
          var label = fs.querySelector('[data-selected-value]');
          if (label) label.textContent = opts[i] || '';
        });
        markAvailability(opts);
        var v = findVariant(opts);
        if (!v) {
          if (addBtn) addBtn.disabled = true;
          if (addLabel) addLabel.textContent = T.strings.unavailable;
          return;
        }
        if (idInput) {
          idInput.value = v.id;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (addBtn) addBtn.disabled = !v.available;
        if (addLabel) addLabel.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
        if (priceWrap) {
          var sale = v.compare && v.compare > v.price;
          priceWrap.classList.toggle('price--sale', !!sale);
          var html = '<span class="price__current">' + formatMoney(v.price) + '</span>';
          if (sale) html += '<s class="price__compare">' + formatMoney(v.compare) + '</s>';
          priceWrap.innerHTML = html;
        }
        if (v.media && gTrack) {
          var idx = Array.prototype.findIndex.call(gTrack.children, function (li) { return Number(li.getAttribute('data-media-id')) === v.media; });
          if (idx > -1) showMedia(idx);
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
      }
      picker.addEventListener('change', update);
      markAvailability(selected());
    });
  }

  /* ---------- Product recommendations ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      if (el.children.length || !el.getAttribute('data-url')) return;
      fetch(el.getAttribute('data-url'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) {
            el.innerHTML = fresh.innerHTML;
            initScrollers(el);
            favRender();
          }
        })
        .catch(function () {});
    });
  }

  /* ---------- Filters: submit on change ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-autosubmit]');
    if (!input) return;
    var form = input.form;
    if (!form) return;
    // Inside the filter drawer the visitor presses "show results"; elsewhere (sorting) submit right away.
    if (input.closest('[data-drawer]')) return;
    var params = new URLSearchParams(new FormData(form));
    params.forEach(function (value, key) { if (value === '') params.delete(key); });
    window.location.href = form.action.split('?')[0] + '?' + params.toString();
  });

  /* ---------- Predictive search ---------- */
  function initPredictive() {
    var input = $('[data-predictive]');
    if (!input || !T.routes.predictiveSearch) return;
    var box = $('[data-predictive-results]');
    var form = input.closest('form');
    var timer, controller;

    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
    function render(data, q) {
      var r = data.resources.results;
      var html = '';
      if (r.products && r.products.length) {
        html += '<div class="predictive__group"><p class="predictive__label">' + esc(T.strings.products) + '</p>';
        r.products.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
          html += '<a class="predictive__item" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="52" height="52">' : '') +
            '<span>' + esc(p.title) + '<small>' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</small></span></a>';
        });
        html += '</div>';
      }
      if (r.collections && r.collections.length) {
        html += '<div class="predictive__group"><p class="predictive__label">' + esc(T.strings.collections) + '</p>';
        r.collections.forEach(function (c) { html += '<a class="predictive__item" href="' + esc(c.url) + '"><span>' + esc(c.title) + '</span></a>'; });
        html += '</div>';
      }
      if (!html) html = '<p class="predictive__empty">' + esc(T.strings.noResults) + '</p>';
      html += '<a class="predictive__all" href="' + esc(T.routes.search) + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">' + esc(T.strings.viewAll) + ' →</a>';
      box.innerHTML = html;
      box.hidden = false;
    }
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { box.hidden = true; return; }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = window.AbortController ? new AbortController() : null;
        var url = T.routes.predictiveSearch + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, controller ? { signal: controller.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (data) { if (data.resources) render(data, q); })
          .catch(function () {});
      }, 220);
    });
    input.addEventListener('keydown', function (e) {
      var items = $$('a', box);
      if (box.hidden || !items.length) return;
      var i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
    });
    box.addEventListener('keydown', function (e) {
      var items = $$('a', box);
      var i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); if (i <= 0) input.focus(); else items[i - 1].focus(); }
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) box.hidden = true; });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') box.hidden = true; });
  }

  /* ---------- Localization: manual + automatic by country ---------- */
  var GEO_KEY = 'anar-geo-v1';
  function storage(get, value) {
    try {
      if (get) return window.localStorage.getItem(GEO_KEY);
      window.localStorage.setItem(GEO_KEY, value);
    } catch (e) { return get ? 'blocked' : null; }
    return null;
  }

  function initLocalization() {
    var form = $('[data-localization-form]');
    if (!form) return;
    // Any manual choice wins over automatic detection.
    form.addEventListener('submit', function () { storage(false, 'manual'); });
    $$('.loc-lang input', form).forEach(function (r) {
      r.addEventListener('change', function () {
        $$('.loc-lang', form).forEach(function (l) { l.classList.toggle('is-active', l.contains(r) && r.checked); });
      });
    });

    var geo = T.geo || {};
    if (!geo.enabled || (window.Shopify && Shopify.designMode)) return;
    if (/bot|crawl|spider|slurp|lighthouse/i.test(navigator.userAgent)) return;
    var state = storage(true);
    if (state) return; // already handled, manual choice, or storage blocked

    fetch('/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var detected = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        storage(false, 'auto');
        if (!detected) return;
        detected = detected.toUpperCase();

        var map = {};
        String(geo.map || '').split(/\r?\n/).forEach(function (line) {
          var parts = line.split(':');
          if (parts.length === 2) map[parts[0].trim().toUpperCase()] = parts[1].trim().toLowerCase();
        });
        var wantLang = map[detected] || map['*'] || geo.currentLanguage;
        if (geo.languages.indexOf(wantLang) === -1) wantLang = geo.currentLanguage;
        var wantCountry = geo.countries.indexOf(detected) > -1 ? detected : geo.currentCountry;

        if (wantLang === geo.currentLanguage && wantCountry === geo.currentCountry) return;

        var countryInput = form.querySelector('[name="country_code"]');
        if (countryInput) countryInput.value = wantCountry;
        var langRadio = form.querySelector('[name="language_code"][value="' + wantLang + '"]');
        if (langRadio) langRadio.checked = true;
        try { window.sessionStorage.setItem('anar-geo-switched', '1'); } catch (e) {}
        HTMLFormElement.prototype.submit.call(form);
      })
      .catch(function () {});
  }

  function geoNotice() {
    var flag;
    try { flag = window.sessionStorage.getItem('anar-geo-switched'); window.sessionStorage.removeItem('anar-geo-switched'); } catch (e) {}
    if (flag && T.strings.geoSwitched) {
      toast(T.strings.geoSwitched, T.strings.geoChange, function () { open('localization-modal'); });
    }
  }

  /* ---------- Birth-data body: live preview ---------- */
  var BODY_COLORS = ['weiss', 'blau', 'rosa', 'rot', 'schwarz'];
  function garmentColorKey(value) {
    var v = String(value || '').toLowerCase();
    if (/schwarz|black|negru|noir/.test(v)) return 'schwarz';
    if (/rosa|pink|roz/.test(v)) return 'rosa';
    if (/rot|red|ro[sș]u|rouge/.test(v)) return 'rot';
    if (/blau|blue|albastru|bleu/.test(v)) return 'blau';
    return 'weiss';
  }

  /* Birth-data body on the real product photo: erase the old texts (inpainting from the fabric around them)
     and write the customer's data with the same fonts. Positions: snippets/birth-photo-config.liquid */
  function hexToRgb(h) { var n = parseInt(h.slice(1), 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; }
  function dist(a, r, g, b) { var dr = a[0] - r, dg = a[1] - g, db = a[2] - b; return Math.sqrt(dr * dr + dg * dg + db * db); }

  // Erase the old text inside "box" by interpolating from the clean fabric around it.
  // keepRgb: colour of the pink details that must stay (only used for the name, where the heart overlaps).
  function eraseText(ctx, box, keepRgb, W, H) {
    var inner = 4, outer = 10;
    var x0 = Math.max(0, Math.floor(box[0]) - outer), y0 = Math.max(0, Math.floor(box[1]) - outer);
    var x1 = Math.min(W - 1, Math.ceil(box[2]) + outer), y1 = Math.min(H - 1, Math.ceil(box[3]) + outer);
    var w = x1 - x0 + 1, h = y1 - y0 + 1;
    var img = ctx.getImageData(x0, y0, w, h), d = img.data;
    var mask = new Uint8Array(w * h);   // pixels to repaint
    var inside = new Uint8Array(w * h); // pixels that must not be used as colour source
    for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
      var gx = x0 + x, gy = y0 + y;
      if (gx < box[0] - inner || gx > box[2] + inner || gy < box[1] - inner || gy > box[3] + inner) continue;
      var k = y * w + x;
      inside[k] = 1;
      if (keepRgb && dist(keepRgb, d[k * 4], d[k * 4 + 1], d[k * 4 + 2]) < 62) continue;
      mask[k] = 1;
    }
    // pink details (heart) may stick out of the box: never use them as colour source
    if (keepRgb) for (var t = 0; t < w * h; t++) if (dist(keepRgb, d[t * 4], d[t * 4 + 1], d[t * 4 + 2]) < 95) inside[t] = 1;
    var out = new Uint8ClampedArray(d);
    for (var yy = 0; yy < h; yy++) for (var xx = 0; xx < w; xx++) {
      var p = yy * w + xx;
      if (!mask[p]) continue;
      var sum = [0, 0, 0], wsum = 0;
      var l = xx, r = xx, u = yy, dn = yy;
      while (l > 0 && inside[yy * w + l]) l--;
      while (r < w - 1 && inside[yy * w + r]) r++;
      while (u > 0 && inside[u * w + xx]) u--;
      while (dn < h - 1 && inside[dn * w + xx]) dn++;
      [[yy * w + l, xx - l], [yy * w + r, r - xx], [u * w + xx, yy - u], [dn * w + xx, dn - yy]].forEach(function (e) {
        if (inside[e[0]]) return;
        var wt = 1 / Math.max(1, e[1]);
        for (var c = 0; c < 3; c++) sum[c] += d[e[0] * 4 + c] * wt;
        wsum += wt;
      });
      var noise = (Math.random() - 0.5) * 3;
      for (var c2 = 0; c2 < 3; c2++) out[p * 4 + c2] = (wsum ? sum[c2] / wsum : d[p * 4 + c2]) + noise;
    }
    img.data.set(out);
    ctx.putImageData(img, x0, y0);
  }

  function fitFont(ctx, family, weight, text, targetH, maxW, refChar) {
    ctx.font = weight + ' 100px ' + family;
    var m = ctx.measureText(refChar || text);
    var asc = m.actualBoundingBoxAscent || 70;
    var size = targetH / asc * 100;
    ctx.font = weight + ' ' + size + 'px ' + family;
    var w = ctx.measureText(text).width;
    if (w > maxW) size = size * maxW / w;
    ctx.font = weight + ' ' + size + 'px ' + family;
    return size;
  }

  function renderBirthPhoto(canvas, img, cfg, values) {
    var W = img.naturalWidth, H = img.naturalHeight;
    var s = W / 1024; // config is measured at 1024 px
    canvas.width = W; canvas.height = H;
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, W, H);
    var keepRgb = cfg.accent ? hexToRgb(cfg.accent) : null;
    var S = {};
    Object.keys(cfg.slots).forEach(function (k) { S[k] = cfg.slots[k].map(function (v) { return v * s; }); });
    var keys = ['name', 'date', 'weight', 'length', 'time'];
    var changed = keys.filter(function (k) { return values[k]; });
    if (!changed.length) return;
    changed.forEach(function (k) { eraseText(ctx, S[k], k === 'name' ? keepRgb : null, W, H); });
    ctx.fillStyle = cfg.inkColor;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'alphabetic';
    var dateBox = S.date, dateH = dateBox[3] - dateBox[1];
    changed.forEach(function (k) {
      var b = S[k], cx = (b[0] + b[2]) / 2, text = values[k];
      if (k === 'name') {
        var nameW = Math.max(b[2] - b[0], (dateBox[2] - dateBox[0]) * 1.12);
        fitFont(ctx, '"Great Vibes", cursive', '400', text, (b[3] - b[1]) * 0.86, nameW, 'L');
        ctx.fillText(text, cx, b[3] - (b[3] - b[1]) * 0.04);
      } else {
        var h = Math.min(b[3] - b[1], dateH * 1.02);
        var maxW = k === 'date' ? (b[2] - b[0]) * 1.08 : (k === 'time' ? (b[2] - b[0]) * 1.4 : (dateBox[2] - dateBox[0]) * 0.42);
        fitFont(ctx, '"Oswald", sans-serif', '300', text, h, maxW, '0');
        ctx.fillText(text, cx, b[3]);
      }
    });
  }


  function initBirth(root) {
    $$('[data-birth]', root).forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var section = box.closest('[data-product]') || document;
      var base = box.getAttribute('data-asset-base');
      var colorIndex = Number(box.getAttribute('data-color-index'));
      var mock = box.querySelector('[data-birth-mock]');
      var svg = box.querySelector('[data-birth-svg]');
      var nameHeart = svg.querySelector('[data-birth-name-heart]');
      var inputs = {}, outs = {}, props = {}, samples = {}, baseSizes = {};
      $$('[data-birth-in]', box).forEach(function (el) { inputs[el.getAttribute('data-birth-in')] = el; });
      $$('[data-birth-prop]', box).forEach(function (el) { props[el.getAttribute('data-birth-prop')] = el; });
      $$('[data-birth-out]', svg).forEach(function (el) {
        var k = el.getAttribute('data-birth-out');
        outs[k] = el;
        samples[k] = el.textContent;
        baseSizes[k] = parseFloat(el.getAttribute('font-size')) || parseFloat(getComputedStyle(el).fontSize) || 100;
      });

      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function formatDate(v) {
        var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v);
        return m ? m[3] + '.' + m[2] + '.' + m[1] : v;
      }
      function displayValue(k, raw) {
        if (!raw) return '';
        if (k === 'date') return formatDate(raw);
        if (k === 'length') return String(raw).replace('.', ',');
        return raw;
      }
      function propValue(k, raw) {
        if (!raw) return '';
        if (k === 'date') return formatDate(raw);
        if (k === 'time') return raw + ' Uhr';
        if (k === 'weight') return raw + ' g';
        if (k === 'length') return String(raw).replace('.', ',') + ' cm';
        return raw;
      }

      function fit(k) {
        var el = outs[k];
        var max = Number(el.getAttribute('data-max-width')) || 500;
        var size = baseSizes[k];
        el.setAttribute('font-size', size);
        try {
          var w = el.getComputedTextLength();
          if (w > max) el.setAttribute('font-size', Math.floor(size * max / w));
        } catch (e) {}
      }

      function placeHeart() {
        if (!nameHeart) return;
        try {
          var b = outs.name.getBBox();
          nameHeart.setAttribute('transform', 'translate(' + Math.min(690, b.x + b.width + 14) + ' ' + (b.y + 40) + ') scale(1.25)');
        } catch (e) {}
      }

      function render() {
        Object.keys(outs).forEach(function (k) {
          var raw = inputs[k] ? inputs[k].value.trim() : '';
          var shown = displayValue(k, raw);
          outs[k].textContent = shown || samples[k];
          outs[k].classList.toggle('is-sample', !shown);
          if (props[k]) {
            props[k].value = propValue(k, raw);
            props[k].disabled = !raw;
          }
          fit(k);
        });
        placeHeart();
        if (typeof schedulePhoto === 'function') schedulePhoto();
      }

      // ---- photo mode: the customer's data on the real product photo (gallery + preview box)
      var photos = null, mediaUrls = [], photoCache = {}, photoTimer, lastPhotoKey = null;
      try { photos = JSON.parse((box.querySelector('[data-birth-photos]') || {}).textContent || 'null'); } catch (e) { photos = null; }
      $$('[data-birth-media]', box).forEach(function (el) { mediaUrls.push(el.getAttribute('data-birth-media')); });
      var canvas = box.querySelector('[data-birth-canvas]');
      function photoFor(key) {
        var pc = photos && photos[key];
        if (!pc || !canvas) return null;
        var url = mediaUrls.filter(function (u) { return u.indexOf(pc.file) > -1; })[0];
        return url ? { cfg: pc, url: url } : null;
      }
      function currentKey() {
        if (colorIndex < 0) return 'weiss';
        var checked = section.querySelector('fieldset[data-option-index="' + colorIndex + '"] input:checked');
        return garmentColorKey(checked ? checked.value : '');
      }
      function galleryImageFor(file) {
        return $$('[data-gallery-track] img', section).filter(function (im) {
          return (im.getAttribute('data-orig-src') || im.currentSrc || im.src || '').indexOf(file) > -1;
        })[0];
      }
      function photoValues() {
        var v = {};
        Object.keys(inputs).forEach(function (k) { var raw = inputs[k].value.trim(); if (raw) v[k] = displayValue(k, raw); });
        return v;
      }
      function drawPhoto() {
        var key = currentKey(), p = photoFor(key);
        box.classList.toggle('birth--photo', !!p);
        if (canvas) canvas.hidden = !p;
        if (!p) return;
        var img = photoCache[p.url];
        if (!img) {
          img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = function () { img.ready = true; drawPhoto(); };
          img.src = p.url;
          photoCache[p.url] = img;
          return;
        }
        if (!img.ready) return;
        var values = photoValues();
        try { renderBirthPhoto(canvas, img, p.cfg, values); } catch (e) { return; }
        // show it in the big gallery as well
        var gImg = galleryImageFor(p.cfg.file);
        if (gImg) {
          if (!gImg.hasAttribute('data-orig-src')) {
            gImg.setAttribute('data-orig-src', gImg.getAttribute('src') || '');
            gImg.setAttribute('data-orig-srcset', gImg.getAttribute('srcset') || '');
          }
          if (Object.keys(values).length) {
            try { gImg.removeAttribute('srcset'); gImg.src = canvas.toDataURL('image/jpeg', 0.9); } catch (e) {}
          } else {
            gImg.src = gImg.getAttribute('data-orig-src');
            if (gImg.getAttribute('data-orig-srcset')) gImg.setAttribute('srcset', gImg.getAttribute('data-orig-srcset'));
          }
          if (key !== lastPhotoKey) {
            var slide = gImg.closest('li'), track = slide && slide.parentElement;
            if (track) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          }
        }
        lastPhotoKey = key;
      }
      function schedulePhoto() {
        if (!photos) return;
        clearTimeout(photoTimer);
        photoTimer = setTimeout(drawPhoto, 140);
      }

      function updateGarment() {
        var key = 'weiss';
        if (colorIndex > -1) {
          var checked = section.querySelector('fieldset[data-option-index="' + colorIndex + '"] input:checked');
          key = garmentColorKey(checked ? checked.value : '');
        }
        if (BODY_COLORS.indexOf(key) === -1) key = 'weiss';
        mock.setAttribute('src', base + 'anar-mock-body-front-' + key + '.jpg');
        var dark = key === 'schwarz' || key === 'rot' || key === 'blau';
        box.style.setProperty('--birth-ink', dark ? '#ffffff' : '#2b2b2b');
        box.classList.toggle('birth--on-red', key === 'rot');
        schedulePhoto();
      }

      box.addEventListener('input', function (e) {
        if (e.target.matches('[data-birth-in]')) {
          e.target.classList.remove('is-invalid');
          box.querySelector('[data-birth-error]').hidden = true;
          render();
        }
      });
      box.addEventListener('change', render);
      section.addEventListener('change', function (e) {
        if (e.target.closest('[data-variant-picker]')) updateGarment();
      });

      updateGarment();
      render();
      if (document.fonts && document.fonts.load) {
        Promise.all([document.fonts.load('100px "Great Vibes"'), document.fonts.load('300 100px "Oswald"')]).then(render, render);
        if (document.fonts.ready) document.fonts.ready.then(render);
      }
    });
  }

  // Do not add to cart while a required birth-data field is empty.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var formId = form.getAttribute && form.getAttribute('id'); // an input named "id" hides form.id
    if (!formId) return;
    var box = $$('[data-birth]').filter(function (b) {
      var prop = b.querySelector('[data-birth-prop]');
      return prop && prop.getAttribute('form') === formId;
    })[0];
    if (!box) return;
    var missing = $$('[data-birth-required]', box).filter(function (el) { return !el.value.trim(); })[0];
    if (!missing) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    missing.classList.add('is-invalid');
    box.querySelector('[data-birth-error]').hidden = false;
    missing.scrollIntoView({ behavior: 'smooth', block: 'center' });
    missing.focus({ preventScroll: true });
  }, true);

  /* ---------- Complete the set ---------- */
  function initSets(root) {
    $$('[data-set]', root).forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var form = document.getElementById(box.getAttribute('data-form-id'));
      var discount = Number(box.getAttribute('data-discount')) || 0;
      var min = Number(box.getAttribute('data-min')) || 2;
      var mainPrice = box.querySelector('[data-set-main-price]');
      var totalEl = box.querySelector('[data-set-total]');
      var beforeEl = box.querySelector('[data-set-before]');
      var btn = box.querySelector('[data-set-add]');
      var label = box.querySelector('[data-set-label]');
      var items = $$('[data-set-item]', box);

      function variantOf(item) {
        var v = item.querySelector('[data-set-variant]');
        var price = v.tagName === 'SELECT' ? v.options[v.selectedIndex].getAttribute('data-price') : v.getAttribute('data-price');
        return { id: Number(v.value), price: Number(price) };
      }
      function recalc() {
        var total = Number(mainPrice.getAttribute('data-price')) || 0;
        var count = 1;
        items.forEach(function (item) {
          var on = item.querySelector('[data-set-toggle]').checked;
          item.classList.toggle('is-off', !on);
          var v = variantOf(item);
          item.querySelector('[data-set-price]').textContent = formatMoney(v.price);
          if (on) { total += v.price; count++; }
        });
        var final = total;
        if (discount > 0 && count >= min) final = Math.round(total * (100 - discount) / 100);
        beforeEl.hidden = final === total;
        beforeEl.textContent = formatMoney(total);
        totalEl.textContent = formatMoney(final);
        label.textContent = label.getAttribute(count > 1 ? 'data-many' : 'data-one');
      }

      box.addEventListener('change', recalc);
      document.addEventListener('variant:change', function (e) {
        if (!form || !box.isConnected) return;
        var v = e.detail && e.detail.variant;
        if (v) {
          mainPrice.setAttribute('data-price', v.price);
          mainPrice.textContent = formatMoney(v.price);
          recalc();
        }
      });

      btn.addEventListener('click', function () {
        if (!form) return;
        if (!form.checkValidity()) { form.reportValidity(); return; }
        var data = new FormData(form);
        var props = {};
        data.forEach(function (value, key) {
          var m = key.match(/^properties\[(.+)\]$/);
          if (m && value !== '' && typeof value === 'string') props[m[1]] = value;
        });
        var mainItem = { id: Number(data.get('id')), quantity: Math.max(1, Number(data.get('quantity')) || 1) };
        if (Object.keys(props).length) mainItem.properties = props;
        var list = [mainItem];
        var feeProps = {};
        var pbox = persoBox(form);
        if (FEE) feeProps[FEE.forLabel] = (pbox && pbox.getAttribute('data-product-title')) || document.title;
        feeVariants(form).forEach(function (id) {
          list.push({ id: id, quantity: mainItem.quantity, properties: feeProps });
        });
        items.forEach(function (item) {
          if (item.querySelector('[data-set-toggle]').checked) list.push({ id: variantOf(item).id, quantity: 1 });
        });
        var body = { items: list };
        var sections = sectionsToRender();
        if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }
        btn.classList.add('is-loading');
        fetch(T.routes.cartAdd + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
          .then(function (res) {
            if (!res.ok || res.json.status) { toast(res.json.description || res.json.message || T.strings.cartError); return; }
            if (res.json.sections && res.json.sections['cart-drawer']) {
              renderDrawer(res.json.sections['cart-drawer']);
              open('cart-drawer');
            } else {
              window.location.href = T.routes.cart;
            }
          })
          .catch(function () { toast(T.strings.cartError); })
          .finally(function () { btn.classList.remove('is-loading'); });
      });

      recalc();
    });
  }

  /* ---------- Favourites (stored in this browser) ---------- */
  var FAV_KEY = 'anar-favorites-v1';
  function favLoad() {
    try { return JSON.parse(window.localStorage.getItem(FAV_KEY)) || []; } catch (e) { return []; }
  }
  function favSave(list) {
    try { window.localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function favRender() {
    var list = favLoad();
    var handles = list.map(function (f) { return f.handle; });
    $$('[data-fav]').forEach(function (b) {
      var on = handles.indexOf(b.getAttribute('data-handle')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = b.querySelector('.fav-btn__label');
      if (label) label.textContent = label.getAttribute(on ? 'data-label-on' : 'data-label-off');
    });
    $$('[data-fav-count]').forEach(function (c) { c.textContent = list.length; c.hidden = list.length === 0; });

    var ul = $('[data-fav-list]');
    var tpl = $('[data-fav-template]');
    var empty = $('[data-fav-empty]');
    if (!ul || !tpl) return;
    ul.innerHTML = '';
    if (empty) empty.hidden = list.length > 0;
    list.forEach(function (f) {
      var node = tpl.content.firstElementChild.cloneNode(true);
      $$('[data-fav-link]', node).forEach(function (a) { a.href = f.url; });
      var im = node.querySelector('[data-fav-img]');
      if (f.image) im.src = f.image; else im.remove();
      node.querySelector('[data-fav-title]').textContent = f.title;
      node.querySelector('[data-fav-price]').textContent = f.price || '';
      node.querySelector('[data-fav-remove]').setAttribute('data-fav-remove', f.handle);
      ul.appendChild(node);
    });
  }

  function favToggle(btn) {
    var handle = btn.getAttribute('data-handle');
    var list = favLoad();
    var idx = list.map(function (f) { return f.handle; }).indexOf(handle);
    if (idx > -1) {
      list.splice(idx, 1);
      toast(T.strings.favRemoved);
    } else {
      list.unshift({
        handle: handle,
        title: btn.getAttribute('data-title'),
        url: btn.getAttribute('data-url'),
        image: btn.getAttribute('data-image'),
        price: btn.getAttribute('data-price')
      });
      btn.classList.remove('is-pop');
      void btn.offsetWidth;
      btn.classList.add('is-pop');
      toast(T.strings.favAdded, T.strings.favView, function () { open('favorites-drawer'); });
    }
    favSave(list);
    favRender();
  }

  /* Refresh titles and prices in the current language/currency when the drawer opens. */
  function favRefresh() {
    var list = favLoad();
    if (!list.length || !window.fetch) return;
    var root = (T.routes.root || '/').replace(/\/?$/, '/');
    Promise.all(list.map(function (f) {
      return fetch(root + 'products/' + encodeURIComponent(f.handle) + '.js')
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function (p) {
          f.title = p.title;
          f.url = root + 'products/' + p.handle;
          f.price = formatMoney(p.price);
          if (p.featured_image) f.image = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=300';
          return f;
        })
        .catch(function () { return f; });
    })).then(function (fresh) { favSave(fresh); favRender(); });
  }

  document.addEventListener('click', function (e) {
    var fav = e.target.closest('[data-fav]');
    if (fav) { e.preventDefault(); favToggle(fav); return; }
    var rem = e.target.closest('[data-fav-remove]');
    if (rem) {
      var h = rem.getAttribute('data-fav-remove');
      favSave(favLoad().filter(function (f) { return f.handle !== h; }));
      favRender();
    }
  });
  window.addEventListener('storage', function (e) { if (e.key === FAV_KEY) favRender(); });

  /* ---------- Customer login: password recovery toggle ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-toggle-recover]')) return;
    var rec = $('[data-recover]');
    var log = $('[data-login]');
    if (rec && log) { rec.hidden = !rec.hidden; log.hidden = !log.hidden; }
  });

  /* ---------- Init ---------- */
  function init(root) {
    initScrollers(root);
    initSliders(root);
    initCountdowns(root);
    initProducts(root);
    initSets(root);
    initBirth(root);
    initShipping(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    liftDrawers();
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);
    init(document);
    favRender();
    initRecommendations();
    initPredictive();
    initLocalization();
    geoNotice();
    if (window.location.hash === '#recover') {
      var rec = $('[data-recover]'), log = $('[data-login]');
      if (rec && log) { rec.hidden = false; log.hidden = true; }
    }
  });

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); favRender(); initRecommendations(); });
})();
